import type { IconNode } from '../types';

/**
 * @name mortar-pestle
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgNGEyIDIgMCAwIDAtMy0xLjdsLTguNSA1LjFBMyAzIDAgMCAwIDEyIDEzYy44IDAgMS41LS4zIDItLjhsNy4zLTYuN2MuNC0uNC43LS45LjctMS41IiAvPgogIDxwYXRoIGQ9Ik0yMiAxMmExMCAxMCAwIDAgMS0yMCAwIiAvPgogIDxwYXRoIGQ9Ik0xMS4xIDdDNiA3LjIgMiA5LjQgMiAxMmMwIDIuOCA0LjUgNSAxMCA1czEwLTIuMiAxMC01YzAtMS41LTEuNC0yLjktMy42LTMuOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/mortar-pestle
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const mortarPestle: IconNode = [
  [
    'path',
    {
      d: 'M22 4a2 2 0 0 0-3-1.7l-8.5 5.1A3 3 0 0 0 12 13c.8 0 1.5-.3 2-.8l7.3-6.7c.4-.4.7-.9.7-1.5',
      key: '49amuo',
    },
  ],
  ['path', { d: 'M22 12a10 10 0 0 1-20 0', key: '8qnpff' }],
  [
    'path',
    {
      d: 'M11.1 7C6 7.2 2 9.4 2 12c0 2.8 4.5 5 10 5s10-2.2 10-5c0-1.5-1.4-2.9-3.6-3.8',
      key: '9lanic',
    },
  ],
];

export default mortarPestle;
